import { UpdateCartHandler } from "@faire/retailer-visitor-shared/stores/domain/CartStore/consts";
import { IQuickAdd } from "@faire/web-api--source/indigofair/data/IQuickAdd";
import React, { lazy } from "react";

export interface IEncapsulatedQuickAddProps {
  productToken: string | undefined;
  quickAdd: IQuickAdd | undefined;
  brandToken: string | undefined;
  imageContainerRef?: React.RefObject<HTMLDivElement | null>;
  updateItems?: UpdateCartHandler;
  onQuickAddClick?: (newQuantity?: number) => void;
  onQuickAddSubmit?: (newQuantity?: number) => void;
  onChooseOption?: () => void;
  onChooseOptionQuantityUpdate?: (newQuantity?: number) => void;
  disableQuickAddWithFaireProtectionTooltip?: boolean;
  className?: string;
  getCartItemTokenByProductToken?: (productToken: string) => void;
}

export const LazyEncapsulatedQuickAdd = lazy(() =>
  import(
    /* webpackChunkName: "encapsulated-quick-add" */ "@faire/retailer-visitor-shared/components/QuickAdd/EncapsulatedQuickAdd"
  ).then((m) => ({ default: m.EncapsulatedQuickAdd }))
);
